/**
 * How long the older lesson-video flow keeps waiting on a HeyGen job.
 *
 * Unlike the video builder, nothing on the server ever fails one of these
 * jobs: the status endpoint asks HeyGen and answers "processing" for as long
 * as it is asked, so a job that never finishes kept its poller running for the
 * life of the page. In the creation wizard that also held Save and Publish
 * disabled, with no way out short of a reload.
 *
 * Admins are told generation takes 5-7 minutes; twenty is clear of a slow one
 * and still ends the wait.
 */
export const LESSON_VIDEO_JOB_DEADLINE_MS = 20 * 60 * 1000;

export const lessonVideoJobExpired = (startedAt: number, now = Date.now()): boolean =>
  now - startedAt >= LESSON_VIDEO_JOB_DEADLINE_MS;
